module.exports = __webpack_public_path__ + "static/media/patient_passport@2x.e9d7def0.png";